import MediaFrame from './MediaFrame';
import forwardRef from '../utils/forwardRef';
export default forwardRef({
  name: 'MediaFrame',
  ClassComponent: MediaFrame
});